<template>
<v-app>
    <nav>
        <v-app-bar class="v-app-bar" app>
      <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
       <v-spacer></v-spacer>

      <v-menu
        class="ml-6"
        v-model="menu"
        offset-y
        transition="slide-y-transition"
        :close-on-content-click="false"
      >
      <template v-slot:activator="{ on, attrs }">
          <v-btn
            icon
          
            v-bind="attrs"
            v-on="on"
          >
            <v-icon large>mdi-account</v-icon>
          </v-btn>
        </template>
        
        <v-list>
           <v-list-item>
            <v-list-item-title>{{ loginUser.firstName + ' ' + loginUser.lastName }}</v-list-item-title>
          </v-list-item>
           <v-list-item>
            <v-list-item-title><v-btn
              color="red"
              text
              @click="$keycloak.logoutFn"
              v-if="$keycloak.authenticated"
            >Logout</v-btn></v-list-item-title>
          </v-list-item>
        </v-list>
       </v-menu>
    </v-app-bar>
    <v-navigation-drawer v-model="drawer" 
    absolute
      dark
      src="https://www.chakray.com/wp-content/uploads/2019/02/Blog_IMGs_Chakray_02-1-b.png"
      app>
  <template v-slot:prepend>
        <v-list-item two-line>
          <v-list-item-avatar>
            <img src="https://global-uploads.webflow.com/61fd034d8ec5a429997fe8ed/6202252cd9e1adf0794f408a_bg%20prismatic%2002%20(1)-min.png">
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title>Prismatic</v-list-item-title>
          
          </v-list-item-content>
        </v-list-item>
      </template>

      <v-divider></v-divider>
      <v-list nav>
        <v-list-item v-for="item in items" :key="item.title" link :to="item.path">
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
       <v-list-group
        :value="false"
        prepend-icon="mdi-cog-outline"
      >
        <template v-slot:activator>
          <v-list-item-title>Setting</v-list-item-title>
        </template>

          <v-list-item
             v-for="item in boardSetting" :key="item.title" link :to="item.path"
          >
          <v-list-item-icon>
          </v-list-item-icon>
             <v-list-item-content>
            <v-list-item-title> <v-icon>{{ item.icon }}</v-icon>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
          </v-list-item>
      </v-list-group>

    </v-navigation-drawer>
     <v-main><router-view></router-view> </v-main>
    </nav>
</v-app>
</template>



<script>
export default {
  name: "App",
  components: {},
  data() {
      return {
      menu: false,
      drawer: true,
      items: [
          { title: 'Base', icon: 'mdi-integrated-circuit-chip', path:'/' },
          { title: 'Serial Number', icon: 'mdi-chip', path:'/serial-number' },
          { title: 'Customer ID', icon: 'mdi-domain', path:'/customer-id' },
          { title: 'Device Type', icon: 'mdi-devices', path:'/device-type' },
          { title: 'Diameter Config', icon: 'mdi-diameter', path:'/diameter' },
        ],
      boardSetting: [
        {title: 'Board', icon: 'mdi-chevron-right', path:'/board' },
        {title: 'Command', icon: 'mdi-chevron-right', path:'/command' },
        {title: 'Group', icon: 'mdi-chevron-right', path:'/group' },
      ],

      };
  },
   computed: {
    loginUser() {
      return this.$store.getters["loginUser/getDetails"];
    },
  },
    created: function() {
    this.$store.dispatch("loginUser/setCurrentUser", {
      firstName: this.$keycloak.tokenParsed.given_name,
      lastName: this.$keycloak.tokenParsed.family_name,
    }); 
    
      }}
  

</script>